import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";
import cn from "classnames";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../Logo";
import Navigation from "../Navigation";
import NavigationItem from "../Navigation/NavigationItem";
import MenuIcon from "../../assets/images/icons/menu.svg?react";
import IconSupport from "../../assets/images/navigation/support.svg?react";
import useStatuses from "../../context/status/useStatuses";
import { isVersionUK } from "../../services/versionService";
import ProfileMenu from "../ProfileMenu";
import { useAuth } from "../../auth";
import "./Sidebar.css";

const Sidebar = () => {
    const { isApplicant } = useStatuses();
    const { pathname } = useLocation();
    const { logOut } = useAuth();

    const [isOpen, setIsOpen] = useState(false);

    const onItemClick = () => {
        if (isOpen) {
            setIsOpen(false);
        }
    };

    return (
        <>
            <div className={cn("Sidebar__header", isOpen ? "Sidebar__header__open" : "")}>
                <Logo className="Sidebar__logo" isSmall />
                <IconButton className="Sidebar__menu-button" onClick={() => setIsOpen((p) => !p)}>
                    {isOpen ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
            </div>
            <div className={cn("Sidebar", isOpen ? "Sidebar__open" : "Sidebar__close")}>
                {isOpen && (
                    <div className="Sidebar__profile">
                        <ProfileMenu notClickable />
                    </div>
                )}
                <Logo className="Sidebar__logo" isWhite={isVersionUK} />
                <div className="Sidebar__content">
                    <div className="Sidebar__navigation">
                        <Navigation onItemClick={onItemClick} />
                    </div>
                    <div className="Sidebar__bottom">
                        {isApplicant && (
                            <>
                                <div className="Sidebar__divider" />
                                <NavigationItem
                                    onItemClick={onItemClick}
                                    icon={IconSupport}
                                    titleKey="contactSupport"
                                    link="/support"
                                    isActive={pathname === "/support"}
                                />
                            </>
                        )}
                        <div className="Sidebar__bottom__mobile">
                            <div className="Sidebar__divider" />
                            <NavigationItem
                                onItemClick={onItemClick}
                                titleKey="editProfile"
                                link="/my-details"
                                isActive={pathname === "/my-details"}
                            />
                            <NavigationItem
                                onItemClick={logOut}
                                titleKey="logOut"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
